import type { ChangeEventHandler } from "react";

import { RadioButton, RadioButtonGroup } from "@jti/core-components";
import type { MagentoShippingMethod } from "@jti/magento-types";

import { isDeliveryOptionSelectable } from "@checkout-v2/shared/utils/prepareDeliveryOptions";

import { ShippingOptionLabel } from "../ShippingOptionLabel";

import styles from "./DeliveryOptionsList.module.scss";

type DeliveryOptionsListProps = {
  options: MagentoShippingMethod[];
  selectionDisabled?: boolean;
  isSubscription?: boolean;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  name: string;
};

export const DeliveryOptionsList = ({
  selectionDisabled,
  isSubscription,
  options,
  value,
  onChange,
  name,
}: DeliveryOptionsListProps) => (
  <div className={styles.container}>
    {selectionDisabled ? (
      options.map(({ methodCode, methodTitle, amount }) => (
        <ShippingOptionLabel key={methodCode} title={methodTitle} amount={amount} />
      ))
    ) : (
      <RadioButtonGroup name={name}>
        {options.map((option) => (
          <RadioButton
            key={option.methodCode}
            value={option.methodCode}
            label={<ShippingOptionLabel title={option.methodTitle} amount={option.amount} />}
            disabled={!isDeliveryOptionSelectable(option, isSubscription)}
            checked={value === option.methodCode}
            onChange={onChange}
          />
        ))}
      </RadioButtonGroup>
    )}
  </div>
);
